import api from './api';

const ipWhitelistService = {
  getIpWhitelist: async (params = {}) => {
    const response = await api.get('/ip-whitelist', { params });
    return response.data;
  },

  getIpWhitelistById: async (id) => {
    const response = await api.get(`/ip-whitelist/${id}`);
    return response.data;
  },

  createIpWhitelist: async (data) => {
    const response = await api.post('/ip-whitelist', data);
    return response.data;
  },

  updateIpWhitelist: async (id, data) => {
    const response = await api.put(`/ip-whitelist/${id}`, data);
    return response.data;
  },

  deleteIpWhitelist: async (id) => {
    const response = await api.delete(`/ip-whitelist/${id}`);
    return response.data;
  }
};

export default ipWhitelistService;
